import { createRoute } from '@tanstack/react-router';
import { GrowthAcquisition } from '@/features/growth/Acquisition';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/growth',
  component: GrowthAcquisition,
});
